/**
 * @static Utility class that helps with the naming conventions inside abb and to receive the right selector
 */
export const selectorHelper = {
  /**
   * @method getSelectorName
   * @param {string} name the name of the currentNode
   * @returns {string} resolves the default name for a selector
   */
  getSelectorName( name ) {
    return name;
  },
  /**
   * @method getFixedPartsName
   * @param {string} name the name of the currentNode
   * @returns {string} resolves the fixed part name for a selector
   */
  getFixedPartsName( name ) {
    return name + ' Fixed Parts';
  },
  /**
   * @method getAccessoriesName
   * @param {string} name the name of the currentNode
   * @returns {string} resolves the Accessory model name for a selector
   */
  getAccessoriesName( name ) {
    return 'Accessories ' + name;
  },
  /**
   * @method getName
   * @param {string} name the name of the currentNode
   * @param {string} activeCategory the name of the active tab
   * @returns {string} returns the right name based on the activeCategory
   */
  getName( name, activeCategory ) {
    switch( activeCategory ) {
      case 'Fixed Parts':
        return this.getFixedPartsName( name );
      case 'Accessories':
        return this.getAccessoriesName( name );
      default:  
        return this.getSelectorName( name );
    }
  },
  getSelectorNode( nodes, items, name, property ) {
      //first look in the tree 
      let searchNode = nodes.firstOrDefault( n => n[property] === name );

      //if not found, look in the complex selectors
      if ( !searchNode ) {
        const complexSelector = items.firstOrDefault( item =>
          item.complexSelector && item.complexSelector.configurations.firstOrDefault( conf => conf.name === name ) );
          const complexNode = complexSelector && nodes.firstOrDefault( n => n[property] === complexSelector.name );
        searchNode = complexNode ? { ...complexNode, complexSelector: true } : searchNode;
      }
      return searchNode;
    }
};